module.exports = __webpack_public_path__ + "img/drag-to-answer-white.9e2e9918.png";